import { FC, ReactNode } from "react";

const Card: FC<{title:ReactNode, subtitle:ReactNode}> = ({title, subtitle}) => {
    return <div className="p-6 flex flex-col gap-4 min-w-50 justify-between rounded-md  bg-background-primary-dark overflow-hidden relative whitespace-nowrap flex-none w-min">
        <div className="absolute -top-1/2 left-1/2 w-[70%] aspect-square rounded-full bg-background-primary"></div>
        <div className="text-white z-10 text-xs uppercase font-semibold text-sm">{title}</div>
        <div className="text-white z-10 font-bold leading-6 text-sm tracking-wider">{subtitle}</div>
    </div>
};

export default Card;